"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AuthCode',
  props: {},
  data: function data() {
    return {
      authCountdown: false,
      authCountTime: 0
    };
  },
  mounted: function mounted() {},
  methods: {
    /**
     * 获取验证码
     */
    getAuthCode: function getAuthCode(params) {
      var _this = this;
      this.codeTime();
      this.$post('commonapi/register/get_captche', params).then(function (res) {}).catch(function () {
        _this.$message({
          message: '验证码发送失败，请重新尝试',
          type: 'error'
        });
        _this.authCountdown = false;
      });
    },
    /**
     * 验证码倒计时
     */
    codeTime: function codeTime() {
      var _this2 = this;
      var TIME_COUNT = 120;
      if (!this.timer) {
        this.authCountTime = TIME_COUNT;
        this.authCountdown = true;
        this.timer = setInterval(function () {
          if (_this2.authCountTime > 0 && _this2.authCountTime <= TIME_COUNT) {
            _this2.authCountTime--;
          } else {
            _this2.authCountdown = false;
            clearInterval(_this2.timer);
            _this2.timer = null;
          }
        }, 1000);
      }
    }
  }
};